import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from 'antd'
import { LogoutOutlined } from '@ant-design/icons'

export const Head = ({ children, activeTab, onLogout }) => {
  const navigate = useNavigate()

  // Получаем роль текущего пользователя из localStorage
  const getCurrentUserRole = () => {
    try {
      const authUser = localStorage.getItem('auth_user');
      if (authUser) {
        const user = JSON.parse(authUser);
        return user.role || 1;
      }
    } catch (error) {
      console.error('Error getting user role:', error);
    }
    return 1; // По умолчанию обычный пользователь
  };

  const userRole = getCurrentUserRole();
  const isAdminOrSuperAdmin = userRole === 2 || userRole === 3;

  return (

    <div className="x_head0"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 10000,
        background: '#FFF'
      }}
    >

      <div className="x_head_l">
        <div className="x_head_logo _click _hover"
          onClick={() => {
            window.open(`/`, '_self')
          }}
        >
          <div className="x_head_logo_text ellipsis">Переводы лекций</div>
        </div>
        <div className="x_head_left">
          <div className="x_head_tabs">
            <div className={`x_head_tab ${activeTab === 'tasks' ? 'active' : ''}`} onClick={() => navigate('/')}>
              <div>Проекты</div>
            </div>
            <div className={`x_head_tab ${activeTab === 'user-tasks' ? 'active' : ''}`} onClick={() => navigate('/user-tasks')}>
              <div>Задачи пользователя</div>
            </div>
            <div className={`x_head_tab ${activeTab === 'subtitles' ? 'active' : ''}`} onClick={() => navigate('/subtitles')}>
              <div>Субтитры</div>
            </div>
            {isAdminOrSuperAdmin && (
              <div className={`x_head_tab ${activeTab === 'people' ? 'active' : ''}`} onClick={() => navigate('/people')}>
                <div>Люди</div>
              </div>
            )}
            {isAdminOrSuperAdmin && (
              <div className={`x_head_tab ${activeTab === 'test-lectures' ? 'active' : ''}`} onClick={() => navigate('/test-lectures')}>
                <div>Тестовые лекции</div>
              </div>
            )}
            <a
              href="https://tts-audio.dev.torsunov.pro/comments"
              className="x_head_tab"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <div>Комментарии</div>
            </a>
          </div>
        </div>
      </div>

      <div className="x_head_center">

      </div>
      <div className="_fm _fr _f _fgap2">
        {children}
        {onLogout && (
          <Button
            type="text"
            icon={<LogoutOutlined />}
            onClick={onLogout}
          >
            Выход
          </Button>
        )}
      </div>


    </div>




  )
}